import { colors } from "healthex-common/colors";
import styled from "styled-components";
import { FlexColumnDiv, FlexRowDiv } from "./common.styles";
import { HXIconButton } from "./HXButton";
import SendIcon from "@mui/icons-material/Send";
import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { fontSizes } from "healthex-common/sizes";
import { IconTextPair } from "./base.styles";
import AddIcon from "@mui/icons-material/Add";
import EditOutlined from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { MessageRole } from "healthex-common/aiassistant.dtos";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
export const AIAssistantParent = styled(FlexRowDiv) `
    display: flex;
    height: 100%;
`;
export const LeftContainer = styled(FlexColumnDiv) `
    width: 300px;
    border-right: 1px solid #e0e0e0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;
export const RightContainer = styled(FlexColumnDiv) `
    flex: 1;
    position: relative;
    height: 100%;
    overflow: hidden;
`;
export const MessageContainer = styled(FlexColumnDiv) `
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 80px;
    overflow-y: auto;
    padding: 20px;
    gap: 20px;
`;
export const QueryContainer = styled.div `
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 80px;
    padding: 20px;
    background: white;
    border-top: 1px solid #e0e0e0;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    box-sizing: border-box;
`;
export const HistoryContainer = styled(FlexColumnDiv) `
    flex: 1;
    overflow-y: auto;
    min-height: 0;
`;
export const AssistantInfo = styled(FlexColumnDiv) `
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 60px;
    height: 100%;
    text-align: center;
    padding: 20px;
`;
export const HelpText = styled(FlexColumnDiv) `
    color: ${colors.black_lighter};
    font-size: ${fontSizes.SUPER};
    text-align: center;
`;
export const ExampleHelpText = styled(FlexColumnDiv) `
    align-items: center;
    margin-top: 20px;
    color: ${colors.black_lighter};
`;
export const SampleQuestionContainer = styled(FlexRowDiv) `
    gap: 10px;
`;
export const Question = styled(FlexColumnDiv) `
    padding: 10px;
    background-color: ${colors.navy_4};
    color: ${colors.black_lighter};
    border-radius: 4px;
    text-align: center;
`;
export const MessageWrapper = styled(FlexColumnDiv) `
    justify-content: ${(props) => (props.role === MessageRole.Human ? "flex-end" : "flex-start")};
`;
export const Message = styled(FlexColumnDiv) `
    padding: 0px 15px;
    border: 4px;
    color: ${(props) => (props.role === MessageRole.Human ? colors.white_main : colors.black_lighter)};
    background-color: ${(props) => (props.role === MessageRole.Human ? colors.navy_main : colors.navy_4)};
    align-self: ${(props) => (props.role === MessageRole.Human ? "flex-end" : "flex-start")};
    max-width: 60%;
    margin-right: ${(props) => (props.role === MessageRole.Human ? "15px" : "0")};
    margin-left: ${(props) => (props.role === MessageRole.Human ? "0" : "15px")};
    border-radius: 4px;
`;
export const MessageActionsRow = styled(FlexRowDiv) `
    padding: 0px 15px;
    margin-top: 8px;
    gap: 8px;
    justify-content: ${(props) => (props.role === MessageRole.Human ? "flex-end" : "flex-start")};
`;
export const CopyActionIcon = styled(ContentCopyIcon) `
    color: ${colors.black_lighter};
    cursor: pointer;
`;
export const AILoading = styled(FlexRowDiv) `
    gap: 10px;
`;
const AIClearButtonIcon = styled(SendIcon) `
    width: 24px;
    height: 24px;
    color: ${colors.black_lighter};
`;
export const AIClearButton = styled(HXIconButton).attrs({ children: React.createElement(AIClearButtonIcon) }) `
    padding: 0;
`;
export const SpinnerContainer = styled.div `
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 6px;
`;
export const Spinner = styled(CircularProgress).attrs({ size: 14 }) `
    padding: 15px;
    sx: {
        color: ${colors.navy_main};
    }
`;
export const PatientHealthSystemSelectContent = styled(FlexColumnDiv) `
    gap: 16px;
    padding: 5px;
    margin-top: 10px;
`;
export const OriginatorMenuItem = styled.div `
    ${IconTextPair}
    gap: 10px;
`;
export const OriginatorLogo = styled.img `
    object-fit: contain;
    max-height: 20px;
    width: 30px;
`;
export const ChatHistoryContainer = styled.div `
    padding: 10px;
    width: 100%;
`;
export const ChatHistoryHeader = styled.div `
    flex: 0 0 auto;
    padding: 20px;
    font-size: 18px;
    font-weight: 500;
    color: ${colors.black_lighter};
    border-bottom: 1px solid #e0e0e0;
`;
export const ChatHistoryItem = styled.div `
    display: flex;
    align-items: center;
    background-color: #f5f5f5;
    padding: 12px;
    border-radius: 8px;
    margin-bottom: 8px;
    cursor: pointer;
    transition: background-color 0.2s;
    width: 100%;
    box-sizing: border-box;

    &:hover {
        background-color: #e9e9e9;
    }
`;
export const ChatContent = styled.div `
    flex: 1;
    color: #333;
`;
export const ChatTimestamp = styled.div `
    margin-left: 8px;
    opacity: 0.6;
    font-size: 12px;
    color: #666;
`;
export const NoChatsMessage = styled.div `
    padding: 20px;
    text-align: center;
    color: #666;
`;
export const ConversationList = styled(FlexColumnDiv) `
    flex: 1;
    overflow-y: auto;
    padding: 8px;
`;
export const ConversationItem = styled.div `
    padding: 12px;
    cursor: pointer;
    border-bottom: 1px solid ${colors.navy_4};
    background-color: ${(props) => (props.isActive ? colors.navy_30 : "transparent")};
    border-radius: 8px;

    &:hover {
        background-color: ${(props) => (props.isActive ? colors.navy_30 : colors.navy_4)};
        .edit-icon,
        .delete-icon {
            opacity: 0.5;
        }
    }

    transition: background-color 0.2s ease;
`;
export const ConversationTitle = styled.div `
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;
export const ConversationTimestamp = styled.div `
    font-size: 12px;
    color: ${colors.black_lighter}80;
`;
export const AddConversationButton = styled.button `
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin: 16px;
    padding: 10px;
    background: ${colors.navy_main};
    color: ${colors.white_main};
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.2s;
    font-weight: 500;

    &:hover {
        background: ${colors.navy_dark};
    }

    svg {
        font-size: 20px;
    }
`;
export const AddConversationIcon = styled(AddIcon) `
    width: 20px;
    height: 20px;
`;
export const EditConversationIcon = styled(EditOutlined) `
    margin-left: auto;
    opacity: 0;
    cursor: pointer;
    font-size: 36px;

    &:hover {
        opacity: 1;
    }
`;
export const ConversationTitleInput = styled.input `
    width: 90%;
    padding: 8px;
    border: 1px solid ${colors.navy_4};
    border-radius: 4px;
    font-size: 14px;

    &:focus {
        outline: none;
        border-color: ${colors.navy_main};
    }
`;
export const DeleteConversationIcon = styled(DeleteOutlineIcon)({
    fontSize: "36px",
    marginLeft: "8px",
    opacity: 0,
    cursor: "pointer",
    color: "#666",
    "&:hover": {
        color: "#ff4444",
    },
});
export const MetadataContainer = styled.div `
    margin-top: 8px;
    margin-bottom: 16px;
    font-size: 12px;
    color: #666;
    font-style: italic;
`;
export const ToolBadge = styled.span `
    background: #f0f0f0;
    padding: 2px 6px;
    border-radius: 4px;
    margin-right: 4px;
    font-size: 11px;
`;
export const LoadMoreButton = styled.button `
    background: #f0f0f0;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 8px 16px;
    margin: 8px 0;
    cursor: pointer;
    font-size: 14px;
    color: #333;

    &:hover {
        background: #e0e0e0;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;
